import React, { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import "../../../assets/css/superadmin/superadmin.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faInfoCircle, faCog, faClose, faBars } from '@fortawesome/free-solid-svg-icons';
import schart from '../../../assets/images/schart.png';
import shome from '../../../assets/images/shome.png';


import Superdashboard from '../../../assets/images/superadmin/superdashboard.svg';
import Superorganisation from '../../../assets/images/superadmin/superorganisation.svg';
import Supersuperticket from '../../../assets/images/superadmin/supersuperticket.svg';
import Supermoduleupdate from '../../../assets/images/superadmin/supermoduleupdate.svg';
import Superallstation from '../../../assets/images/superadmin/superallstation.svg';
// import { useLocation } from "react-router-dom";
import { useAuth, useAuthRFS, useAuthULD, useAuthASR, useAuthHRFS, useAuthSAdmin } from '../../../useAuth/useAuth';

const LeftMenu = ({ onNav }) => {
    const initialTab = localStorage.getItem('tab')
    const [selectedTab, setSelectedTab] = useState(initialTab || 'D');
    const [isIconClosed, setIsIconClosed] = useState(false);

    const navItems = [
        { path: 'D', image: Superdashboard, name: 'Dashboard' },
        { path: 'O', image: Superorganisation, name: 'Organisation' },
        { path: 'S', image: Supersuperticket, name: 'Support' },
        { path: 'M', image: Supermoduleupdate, name: 'Modules' },
        { path: 'A', image: Superallstation, name: 'All Station' },
    ];

    const handleMenuChange = (path) => {
        setSelectedTab(path)
        localStorage.setItem('tab', path)
        onNav(path);
    }
    const handleIconClick = () => {
        setIsIconClosed(!isIconClosed);
        document.body.classList.toggle('sidebar-icon-only');
        // Add your additional logic or toggle state as needed
    };
    const isSidebarIconOnly = document.body.classList.contains('sidebar-icon-only');

    return (
        <nav className="sidebar sidebar-offcanvas for_super spr-left" id="sidebar">

            <div className="hmenu">
                <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={handleIconClick}>
                    <FontAwesomeIcon icon={isSidebarIconOnly ? faClose : faBars} />
                </button>
            </div>


            <ul className="nav spr-left">
                {navItems?.map((item, index) => (
                    <li key={index}>
                        {/* {console.log("img", item.image)} */}
                        <Link to='#' className={`nav-link ${selectedTab === item.path ? 'active' : ''} rounded`} onClick={() => handleMenuChange(item.path)}>
                            <span className="nav-icon">
                                <img src={item.image} />
                            </span>
                            {isIconClosed && <span>{item.name}</span>}
                            {/* <span className="act-sign"></span> */}
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
export default LeftMenu;